import React, { useState, useRef, useLayoutEffect, useCallback } from 'react';
import Category from './components/Category';
import CategoryMenu from './components/CategoryMenu';
import CardPopup from './components/CardPopup';
import IconSprite from './components/sprites/IconSprite';
import LogoButton from './components/buttons/LogoButton';
import PhoneButton from './components/buttons/PhoneButton';
import { categories, categoryHeight } from './constants';
import { uuid } from './utils';

const App = () => {
  const container = useRef(null);
  const clones = useRef(null);
  const [phone, setPhone] = useState('');
  const [activeCategory, setActiveCategory] = useState(0);
  const [modalIsOpen, setIsOpen] = useState(false);
  let disableScroll = false;
  let scrollPos = 0;
  let scrollPanelHeight = 20;

  const getScrollPos = () => {
    return (
      (container.current.pageYOffset || container.current.scrollTop) -
      (container.current.clientTop || 0)
    );
  };

  const setScrollPos = (pos) => {
    container.current.scrollTop = pos;
  };

  const scrollUpdate = useCallback(() => {
    if (!disableScroll) {
      scrollPos = getScrollPos();
      // setActiveCategory(Math.floor(scrollPos / (categoryHeight - 70)));

      if (
        clones.current.offsetHeight + scrollPos + scrollPanelHeight >=
        container.current.scrollHeight
      ) {
        setScrollPos(1);
        disableScroll = true;
      } else if (scrollPos <= 0) {
        setScrollPos(
          container.current.scrollHeight -
            clones.current.offsetHeight -
            scrollPanelHeight
        );
        disableScroll = true;
      }
    }
    if (disableScroll) {
      window.setTimeout(function () {
        disableScroll = false;
      }, 40);
    }
  });

  useLayoutEffect(() => {
    window.requestAnimationFrame(scrollUpdate);
  }, [scrollUpdate]);

  const handleScroll = () => {
    window.requestAnimationFrame(scrollUpdate);
  };

  const scrollTo = (category) => {
    setScrollPos(category * categoryHeight);
    setActiveCategory(category);
  };

  return (
    <div className="main" ref={container} onScroll={handleScroll}>
      <LogoButton handleClick={() => scrollTo(0, 1)} />
      <PhoneButton />
      <CategoryMenu
        categories={categories}
        handleClick={scrollTo}
        activeCategory={activeCategory}
      />
      <div className="categories">
        {categories.map((category, i) => (
          <Category
            key={uuid()}
            category={category}
            openModal={() => {
              setIsOpen(true);
            }}
          />
        ))}
      </div>
      <div className="categories clones" ref={clones}>
        {categories.slice(0, 2).map((category) => (
          <Category
            key={uuid()}
            category={category}
            openModal={() => {
              setIsOpen(true);
            }}
          />
        ))}
      </div>
      <IconSprite />
      <CardPopup
        modalIsOpen={modalIsOpen}
        closeModal={() => setIsOpen(false)}
        phone={phone}
        setPhone={setPhone}
      />
    </div>
  );
};

export default App;
